<script setup lang="ts">
import { computed } from 'vue'

const {
  height,
  service,
  serviceOtherUrl,
  src,
  width
} = defineProps<{
  height: number
  service: 'youtube' | 'vimeo' | 'other'
  serviceOtherUrl?: string // if service is other
  src: string
  width: number
}>()

const serviceUrl = computed(() => {
  if (service === 'other' && !serviceOtherUrl)
    return ''
  if (service === 'youtube')
    return 'https://www.youtube.com/embed/'
  if (service === 'vimeo')
    return 'https://player.vimeo.com/video/'
  return ''
})
</script>

<template>
  <div class="video-responsive">
    <iframe
      :width="width"
      :height="height"
      :src="`${serviceUrl}${src}`"
      frameborder="0"
      allowfullscreen
    />
  </div>
</template>

<style scoped>
.video-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}

.video-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
</style>
